<template>
  <div>
    <FilterChip
      :is-active="Boolean(selectedCity?.name)"
      :name="selectedCity?.name || 'Выбрать город'"
      @click="isVisibleModal = true"
      @click:close="onReset"
    />

    <CoreSelectionDrawer
      has-search
      has-footer
      title="Выбрать город"
      placeholder="Найти"
      :value="isVisibleModal"
      :items="cities"
      :selected-item="selectedCity"
      :loading="loading"
      :error="error"
      @input="isVisibleModal = false"
      @click-item="handleClickCity"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, toRefs, watch } from 'vue'
import useSnackbar from 'src/composables/useSnackbar'
import FilterChip from 'src/components/pages/memorial/MemoryBoardPage/components/DoctorFilter/FilterChip.vue'
import CoreSelectionDrawer from 'src/core/CoreSelectionDrawer/CoreSelectionDrawer.vue'
import type { ApiTownResponseGet } from 'src/components/pages/memorial/MemoryBoardPage/api/apiTownList.type'
import apiTownList from 'src/components/pages/memorial/MemoryBoardPage/api/apiTownList'

const emit = defineEmits(['input'])

const props = defineProps<{ value?: ApiTownResponseGet[number] }>()
const { value: selectedCity } = toRefs(props)

const snackbar = useSnackbar()

const cities = ref<ApiTownResponseGet>([])
const citiesCache: Map<string, ApiTownResponseGet> = new Map()
const loading = ref(false)
const error = ref(false)
const isVisibleModal = ref(false)

const loadCities = async () => {
  error.value = false
  loading.value = true

  try {
    const requestData = {}
    const cacheKey = JSON.stringify(requestData)

    if (!citiesCache.has(cacheKey)) {
      const { data } = await apiTownList.get()

      citiesCache.set(cacheKey, data)
    }

    cities.value = citiesCache.get(cacheKey) || []
  } catch {
    error.value = true
  } finally {
    loading.value = false
  }
}

watch(isVisibleModal, async () => {
  if (isVisibleModal.value) {
    await loadCities()
  }
})

const handleClickCity = (city: ApiTownResponseGet[number]) => {
  emit('input', city)
  isVisibleModal.value = false
}

const onReset = () => {
  emit('input', undefined)
  snackbar.show('Фильтр сброшен')
}
</script>
